import axios from "../axios-auth";
import orginal_axios from "axios";

export const stockTemplateService = {
    getStockTemplateList,
    saveStockTemplate,
    getStockTemplateDetail,
    saveStockTemplateExcel,
    getStockTemplateExcelTemplate
};

function getStockTemplateList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/stock-templates", { params });
}

function saveStockTemplate(stockTemplate) {
    if (!stockTemplate.id) {
        // new stock template
        return axios.post("/auth/stock-template", stockTemplate);
    } else {
        // edit
        return axios.put("/auth/stock-template", stockTemplate);
    }
}

function getStockTemplateDetail(id) {
    return axios.get("/auth/stock-template/" + id);
}

function saveStockTemplateExcel(file) {
    return axios.post('/auth/stock-template-excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

function getStockTemplateExcelTemplate() {
    return orginal_axios({
      method: "GET",
      url: axios.defaults.baseURL + "/auth/stock-template-excel-template",
      responseType: "arraybuffer", // important
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }
    }).then(function (response) {
      return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
  }


